import React from 'react';
import _ from 'underscore';
import { ContentViewRegular, ImageMultipleRegular, VideoRegular } from '@fluentui/react-icons';
import { AdFormat } from '@bingads-webui-campaign-react/display-plus-native-ads';

const iconSize = 22;

export const getConfigByType = (type) => {
  switch (type) {
    case AdFormat.Native:
      return {
        icon: <ContentViewRegular fontSize={iconSize} />,
        label: _TL_('Native ad'),
      };
    case AdFormat.Display:
      return {
        icon: <ImageMultipleRegular fontSize={iconSize} />,
        label: _TL_('Display ad'),
      };
    default: // Video
      return {
        icon: <VideoRegular fontSize={iconSize} />,
        label: _TL_('Video ad'),
      };
  }
};

export const getDescriptionByType = (ad, type, i18n) => {
  switch (type) {
    case AdFormat.Native: {
      const imageCount = ad && ad.Images && ad.Images.ImageList && ad.Images.ImageList.length;
      const headLinesCount = _.keys(ad && ad.Headlines).length;
      const longHeadLinesCount = _.keys(ad && ad.LongHeadlines).length;
      const descriptionCount = _.keys(ad && ad.Descriptions).length;
      return i18n.getString(_TL_('{{imageCount}} images, {{headlineCount}} headlines, {{descCount}} descriptions'), {
        imageCount,
        headlineCount: headLinesCount + longHeadLinesCount,
        descCount: descriptionCount,
      });
    }
    case AdFormat.Display: {
      const { targetWidth, targetHeight } = ad.data.image;
      return `${targetWidth}x${targetHeight}`;
    }
    default: { // Video
      // If the video is still transcoding, we don't have the duration yet
      if (!ad.data.video.duration) {
        return '';
      }

      const videoDuration = ad.data.video.duration / 1000;
      const minutes = Math.floor(videoDuration / 60);
      const seconds = Math.floor(videoDuration % 60);
      const formattedDuration = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      return formattedDuration;
    }
  }
};
